module.exports = __webpack_public_path__ + "img/shipping.da5a589d.png";